import React from 'react';
import { ActionMenuIcons } from '@bbkAdminComponents/action-menu/action-menu-icons';
import type { CardData } from '@bbkAdminUtils/offer-play-objectives';

const OfferObjectiveCard: React.FC<{
  data: CardData;
  onClick: () => void;
  containerClass?: string;
}> = ({ data, onClick, containerClass = '' }) => (
  <div
    className={`tw-mr-1 tw-mt-1 tw-flex tw-w-full tw-cursor-pointer tw-gap-2 tw-rounded-lg tw-border tw-bg-white tw-p-6 hover:tw-bg-cbrneutral-100 ${containerClass}`}
    onClick={onClick}
  >
    <div className="tw-h-[4rem] tw-w-[4rem]">{data.image}</div>
    <div className="tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-gap-0.5">
      <div className="tw-text-lg tw-font-bold">{data.title}</div>
      <p className="tw-text-sm">{data.subtitle}</p>
    </div>
    <div className="tw-flex tw-items-center tw-justify-center">
      <span className="tw-text-cbrneutral-800">
        {ActionMenuIcons.arrowRight}
      </span>
    </div>
  </div>
);

export default OfferObjectiveCard;
